// extracted by mini-css-extract-plugin
export var cell = "_5j-4";
export var headerCell = "_5j-2";
export var rowHeader = "_5j-3";
export var table = "_5j-1";
export var tableContainer = "_5j-0";